<template>
  <div>
  <div id="time-row">
    <div class="time-btn" id="time-back-btn"
         v-on:click="scrollTime(false)">
    <font-awesome-icon :icon="['fas', 'chevron-circle-left']" size="lg"/>
    </div>
    <div><h1>{{ allMonths[displayMonth-1] }} {{displayYear}}</h1></div>
    <div class="time-btn" id="time-forward-btn"
         v-on:click="scrollTime(true)">
    <font-awesome-icon :icon="['fas', 'chevron-circle-right']" size="lg"/>
    </div>
  </div>
  <div :class="{'calendar':true, 'weekly-calendar':weeklyView}">
    <div class="control-row">
      <div class="toggle-btn">
        <p :class="{'selected':weeklyView}" v-on:click="weeklyView = true">Weekly</p>
        <p :class="{'selected':!weeklyView}" v-on:click="weeklyView = false">Monthly</p>
      </div>
    </div>
    <div :class="{'table-scrollable':weeklyView}" id="table-scrollable">
    <table>
      <thead>
        <tr>
          <th v-if="weeklyView" style="width: 40px;"></th> <!-- space for labels -->
          <th v-for="(date, i) in displayDates[0]"
              :key="'weekday-names-'+i" id="weekday-names">
            <div v-if="weeklyView">
              {{ allDaysOfWeek[i] }} {{ date.month + "/" + date.date}}
            </div>
            <div v-else>{{ allDaysOfWeek[i] }}</div>
          </th>
        </tr>
      </thead>
      <tbody>
        <Week v-for="i in weeksInDisplay" :key="'week-'+i"
              :info="info"
              :displayYear="displayYear"
              :displayMonth="displayMonth"
              :displayWeek="displayDates[i-1]"
              :todaysDate="todaysDate"
              :weeklyView="weeklyView"/>
      </tbody>
    </table>
  </div>
    <!--<p> {{ info }} </p>-->
  </div>
  </div>
</template>

<script>
import Week from '../components/Week.vue'

let currentDate = new Date();

export default {
  name: 'Calendar',
  components: {
    Week
  },
  props: {
    info: { type: Array, required: true },
  },
  data() {
    return {
      weeklyView: false,
      allMonths: ["January", "February", "March", "April", "May", "June",
                  "July", "August", "September", "October", "November", "December"],
      allDaysOfWeek: ["Sun", "Mon", "Tues", "Weds", "Thurs", "Fri", "Sat"],
      displayYear: currentDate.getFullYear(),
      displayMonth: currentDate.getMonth() + 1, // +1 since getMonth is zero indexed
      displayDay: currentDate.getDate(),
      todaysDate: this.getStringDate(currentDate.getMonth()+1, currentDate.getDate(), currentDate.getFullYear())
    }
  },
  watch: {
    displayMonth: function() {
      let firstOfLastMonth = this.getStringDate(this.displayMonth-1, 1, this.displayYear);
      this.$emit('month-change', firstOfLastMonth);
    }
  },
  methods: {
    getStringDate(month, day, year) {
      let mm = (month < 10) ? ("0"+month) : month;
      let dd = (day < 10) ? ("0"+day) : day;
      return year + "-" + mm + "-" + dd;
    },
    monthViewDates(month, year) { // month is 0 indexed
      // get list of dates shown in month view
      let prevMonthLength = new Date(year, month, 0).getDate(); // # days in prev month
      let daysInMonth = new Date(year, month+1, 0).getDate(); // # days in current month
      let firstDay = new Date(year, month, 1).getDay(); // day of the week of 1st
      let firstDisplayDay = prevMonthLength - firstDay + 1; // first visible date
      if (firstDay === 0) { firstDisplayDay = 1; }

      let displayDaysArr = [];
      let weekDaysArr = [];
      let numWeeks = this.weeksInMonth(month, year);

      let prevMonth = new Date(year, month-1, 1);
      let nextMonth = new Date(year, month+1, 1);
      let dateToAdd = firstDisplayDay;

      for (let i = 0; i < numWeeks; i++) {
        for (let j = 0; j < 7; j++) {
          // grey out days not in current month
          if (i == 0 && dateToAdd > 7) {
            weekDaysArr.push({"month": prevMonth.getMonth()+1,
                              "year" : prevMonth.getFullYear(),
                              "date": dateToAdd, "greyedOut": true});
          }
          else if (i > 1 && dateToAdd < 7) {
            weekDaysArr.push({"month": nextMonth.getMonth()+1,
                              "year" : nextMonth.getFullYear(),
                              "date": dateToAdd, "greyedOut": true});
          }
          else {
            weekDaysArr.push({"month": month+1, "year" : year,
                              "date": dateToAdd, "greyedOut": false});
          }

          if (i == 0 && dateToAdd > 7 && dateToAdd == prevMonthLength) {
            dateToAdd = 1;
          }
          else if (i > 0 && dateToAdd == daysInMonth) { dateToAdd = 1; }
          else { dateToAdd++; }
        }
        displayDaysArr.push(weekDaysArr);
        weekDaysArr = [];
      }
      return displayDaysArr;
    },
    weeksInMonth(month, year) { // month = # (0 indexed), year = #
      let firstDay = new Date(year, month, 1).getDay(); // day of the week of 1st
      let daysInMonth = new Date(year, month+1, 0).getDate();
      return Math.ceil((firstDay + daysInMonth) / 7);
    },
    scrollTime: function(scrollForward) {
      if (scrollForward) {
        if (this.weeklyView) {  // change week for weekly view
          let daysInMonth = new Date(this.displayYear, this.displayMonth, 0).getDate(); // # days in current month
          if (this.displayDay + 7 > daysInMonth) {   // overflow -> change month
            this.displayDay = this.displayDay + 7 - daysInMonth;
            if (this.displayMonth + 1 <= 12) { this.displayMonth += 1; }
            else {   // overflow -> change year
              this.displayMonth = 1;
              this.displayYear += 1;
            }
          } else {
            this.displayDay += 7;
          }
        } else {  // change month for monthly view
          this.displayDay = 1;
          if (this.displayMonth + 1 <= 12) { this.displayMonth += 1; }
          else {   // overflow -> change year
            this.displayMonth = 1;
            this.displayYear += 1;
          }
        }
      } else {
        if (this.weeklyView) {  // change week for weekly view
          let daysInPrevMonth = new Date(this.displayYear, this.displayMonth-1, 0).getDate(); // # days in current month
          if (this.displayDay - 7 < 1) {   // overflow -> change month
            this.displayDay = daysInPrevMonth + (this.displayDay - 7);
            if (this.displayMonth - 1 >= 1) { this.displayMonth -= 1; }
            else {   // overflow -> change year
              this.displayMonth = 12;
              this.displayYear -= 1;
            }
          } else {
            this.displayDay -= 7;
          }
        } else {  // change month for monthly view
          this.displayDay = 1;
          if (this.displayMonth - 1 >= 1) { this.displayMonth -= 1; }
          else {   // overflow -> change year
            this.displayMonth = 12;
            this.displayYear -= 1;
          }
        }
      }
    }
  },
  computed: {
    weeksInDisplay: function() {
      let month = this.displayMonth-1;
      let year = this.displayYear;

      if (!this.weeklyView) { return this.weeksInMonth(month, year); }
      return 1;
    },
    displayDates: function() { // month is 0 indexed
      let day = this.displayDay;
      let month = this.displayMonth-1;
      let year = this.displayYear;

      if (!this.weeklyView) {
        return this.monthViewDates(month, year);
      }
      // get display dates for weekly view
      let displayDaysArr = [];

      // add in overflow from last month
      let todayDayOfWeek = new Date(year, month, day).getDay(); // 0 = sunday, etc.
      let weekStart = day - todayDayOfWeek;
      if (weekStart <= 0) { // if negative, then part of last month
        let prevMonth = new Date(year, month-1, 1);
        let prevMonthLength = new Date(year, month, 0).getDate(); // # days in prev month
        for (let i = prevMonthLength + weekStart; i <= prevMonthLength; i++) {
          displayDaysArr.push({"month": prevMonth.getMonth()+1,
                               "year": prevMonth.getFullYear(),
                               "date": i, "greyedOut": true});
        }
        weekStart = 1;
      }

      // add in overflow to next month
      let tempArr = [];
      let weekEnd = day + (7 - (todayDayOfWeek+1));
      let daysInMonth = new Date(year, month+1, 0).getDate(); // # days in current month
      if (weekEnd > daysInMonth) { // if > # days in current month
        let nextMonth = new Date(year, month+1, 1);
        for (let i = 1; i <= weekEnd - daysInMonth; i++) {
          tempArr.push({"month": nextMonth.getMonth()+1,
                        "year": nextMonth.getFullYear(),
                        "date": i, "greyedOut": true});
        }
        weekEnd = daysInMonth;
      }

      for (let i = weekStart; i <= weekEnd; i++) {
        displayDaysArr.push({"month": month+1, "year": year,
                             "date": i, "greyedOut": false});
      }
      return [displayDaysArr.concat(tempArr)];
    },
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h1 {
  margin: 0px 0 0;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}

.calendar {
  margin: auto;
  width: 85%;
}
.weekly-calendar {
  width: 87%;
  margin-left: 5.5%;
}

#time-row div {
  display: inline-block;
  vertical-align: middle;
  padding: 0px 10px;
}
.time-btn {
  color: rgba(0, 179, 152, 0.5);
}
.time-btn:hover {
  cursor: pointer;
  color: rgba(0, 179, 152, 0.7);
}

.control-row {
  min-height: 32px;
  position: relative;
}

.toggle-btn {
  position: absolute;
  top: -8px;
  right: 4px;
  padding: 4px;
  border-radius: 2px;
  background-color: rgba(0, 179, 152, 0.3);
  box-shadow: inset 0px 4px 16px 0px rgba(0, 0, 0, 0.1);
}

.toggle-btn p {
  display: inline-block;
  margin: 0px;
  border-radius: 2px;
  padding: 4px 8px 2px 8px;
  font-size: 15px;
}
.toggle-btn p:hover {
  cursor: pointer;
}
.toggle-btn .selected {
  background-color: white;
  box-shadow: 0 0px 2px 0 rgba(0, 0, 0, 0.2);
}

table {
  width: 100%;
  table-layout: fixed;
}

.table-scrollable {
  max-height: 600px;
  overflow-y: scroll;
  min-width: 500px;
}
.table-scrollable th {
  z-index: 1;
  position: sticky;
  margin: 0px;
  padding: 2px;
  top: 0px;
  background-color: white;
}
</style>
